module.exports = __webpack_public_path__ + "assets/plus_add_button-5775ea.svg";